import { withStyles } from '@material-ui/core';

import StoreListContentForm from './component';
import styles from './styles';

export default withStyles(styles)(StoreListContentForm);
